import api from "@/api/api";

export const extractFileData = (formData) => {
  return api.post("/extract", formData);
};
